export function sendEmailFormValidation(values, errors) {
  if (values.email) {
    if (!values.email.match(/^.+@.+[.]\w+$/)) {
      errors.email = 'Email must be valid'
    } else {
      delete errors.email
    }
  } else if (values.name) {
    if (!values.name.match(/^\w+ ?\w+$/)) {
      errors.name = 'Name must be in the form'
    } else {
      delete errors.name
    }
  }

  return errors
}
